import React, { useContext, useEffect } from 'react';
import styles from './Wallet.module.scss';
import { SortParams, useStore } from '../../../../../common';
import { AuthContext } from '../../../../../logic';
import { Table } from 'esa-ui-library';
import { getRows } from './RowProvider';

const Wallet = (): JSX.Element => {
	const [state, dispatch] = useStore();
	const { realBonusHistory, player, realBonusHistoryRows, realBonusHistoryColumns, playerLoading } = state;
	const { token } = useContext(AuthContext);

	const sortHandler = (val: SortParams) => {
		dispatch('REAL_BONUS_HISTORY_SORT', val);
	};

	useEffect(() => {
		dispatch('LOADING', true);
		dispatch('REAL_BONUS_HISTORY_INIT', { token, playerId: player.playerData.player_id });
	}, []);

	useEffect(() => {
		dispatch('UPDATE_REAL_BONUS_HISTORY_ROWS', getRows(realBonusHistory));
	}, [realBonusHistory]);

	return (
		<section className={styles.Wallet}>
			<Table
				titles={realBonusHistoryColumns}
				data={realBonusHistoryRows}
				className={styles.WalletTable}
				rowClassName={styles.WalletRow}
				isLoading={playerLoading}
				onSort={sortHandler}
				emptyStateText='No data found for this player'
			/>
		</section>
	);
};
export { Wallet };
